import { ApplicationDto } from './ApplicationDto';
import { CognitoUserDto } from './CognitoUserDto';

export class UserManagementPreload {
  users: Array<CognitoUserDto>
  applications: Array<ApplicationDto>;
  groups: Array<string>;
  enabledAttributes: Array<string>;
}
